//react...
import React from "react";

//styles...
import "./ContactPage.styles.css";

//react-bootstrap...
import { Container ,Card  } from "react-bootstrap";

//data...
import APP_DATA from '../../APP_DATA'

const ContactPage = () => {
    const company=APP_DATA.company;
  return (
    <Container>
      <Card className="text-center m-5 contact-card" border='danger'>
        <Card.Header>Email Address</Card.Header>
        <Card.Body>
          <Card.Title>{company.email}</Card.Title>
          
          
        </Card.Body>
        
      </Card>
      <Card className="text-center m-5 contact-card" border='danger'>
        <Card.Header>Phone</Card.Header>
        <Card.Body>
          <Card.Title>{company.phone}</Card.Title>
          
          
        </Card.Body>
        
      </Card>

      <Card className="text-center m-5 contact-card" border='danger'>
        <Card.Header>Address</Card.Header>
        <Card.Body>
          <Card.Title>{company.address}</Card.Title>
          
          
        </Card.Body>
        
      </Card>
    </Container>
  );
};

export default ContactPage;
